import { defineMessages } from 'react-intl'

export const locale = defineMessages({
  pageNotFound: {
    id: 'page.not-found',
    // eslint-disable-next-line max-len
    defaultMessage: 'The page or event you were looking for went to the Land of Lost Things. We can <a href="/help" >help you</a> find it or take you <a href="/" >home</a>.',
  },
  pageNotFoundCredit: {
    id: 'page.not-found.credit',
    defaultMessage: 'Photography by {name}',
  },
})
